import useThemeVars from '@lib/composables/useThemeVars'
import { exportObjectToGlobalCssProperties } from '@theme/theme.utils'
import type { BasicPalette } from '@theme/theme.types'
import { DEFAULT_LIGHT_PALETTE, GRAY_PRIMARY_VARIANTS } from '@theme/light.const'
import { usePitcherApi } from '@lib/sdk/main'

export default function useTheme() {
  const themeVars = useThemeVars()

  function updateTheme(updatedTheme: Partial<BasicPalette>) {
    Object.assign(themeVars.value, updatedTheme)
    exportObjectToGlobalCssProperties(themeVars.value)
  }

  function updatePrimaryColor(color: string = DEFAULT_LIGHT_PALETTE.primary) {
    const themeToApply =
      color != DEFAULT_LIGHT_PALETTE.primary
        ? {
            primary: color,
            ...GRAY_PRIMARY_VARIANTS,
          }
        : { primary: color }
    updateTheme(themeToApply)
  }

  function defaultThemeFetcher() {
    return usePitcherApi()
      .getEnv()
      .then((env) => ({
        primary: env.pitcher.instance?.color,
      }))
  }
  async function applyEnvironmentTheme(themeFetcher = defaultThemeFetcher) {
    return themeFetcher().then((theme) => {
      const instanceColor = theme.primary
      if (instanceColor) {
        useTheme().updatePrimaryColor(instanceColor)
      }
    })
  }

  return {
    applyEnvironmentTheme,
    updateTheme,
    updatePrimaryColor,
  }
}
